import { Component, input } from '@angular/core'
import { ActiveFilterListComponent } from '../table/filters/active-filter-list/active-filter-list.component'
import { servicePointGroupisplayedFiltersList } from './service-point-group.types'

@Component({
  imports: [ActiveFilterListComponent],
  selector: 'app-service-point-group-filter-list',
  styles: '',
  template: `<app-active-filter-list
    [filterGroup]="groupId()"
    [filterName]="filterNames"
    [allowRemove]="false"
  />`,
})
export class ServicePointGroupFilterListComponent {
  public readonly groupId = input.required<string>()
  public readonly filterNames = servicePointGroupisplayedFiltersList
}
